import { render } from "./ProposalArgumentVideoPlayer.vue?vue&type=template&id=f08796f8"
import script from "./ProposalArgumentVideoPlayer.vue?vue&type=script&lang=js"
export * from "./ProposalArgumentVideoPlayer.vue?vue&type=script&lang=js"

import "./ProposalArgumentVideoPlayer.vue?vue&type=style&index=0&id=f08796f8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__